__turbopack_context__.v({
  "bottom": "CwaVaW_bottom",
  "middle": "CwaVaW_middle",
  "middleComponentContainerDesktop": "CwaVaW_middleComponentContainerDesktop",
  "middleComponentContainerMobile": "CwaVaW_middleComponentContainerMobile",
  "top": "CwaVaW_top",
});
